import React, { useMemo, useRef, useState } from "react";
import Header from "../Component/Header";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
const GOOGLE_SCRIPT_URL =  "https://script.google.com/macros/s/AKfycbwQqbBMPA6eFqeE-3_SMm6qsPuOnNMkjhlNqTl4kS4ik4Z4Zy_eFDY9CXaOqKNPZ3HS2g/exec";
const streams = ["Commerce", "Science", "Arts"];
const genders = ["Male", "Female", "Other"];
const AdmissionClassXI = () => {
  const formRef = useRef(null);
  const [sameSchoolSiblings, setSameSchoolSiblings] = useState([
    { admNo: "", name: "", className: "" },
  ]);
  const [otherSchoolSiblings, setOtherSchoolSiblings] = useState([
    { schoolName: "", name: "", className: "" },
  ]);

  const [errors, setErrors] = useState({});
  const [successMsg, setSuccessMsg] = useState("");

  // Convert siblings arrays to JSON so Apps Script can store them in a single cell
  const sameSchoolJson = useMemo(
    () =>
      JSON.stringify(
        sameSchoolSiblings
          .map((s) => ({
            admNo: s.admNo?.trim(),
            name: s.name?.trim(),
            className: s.className?.trim(),
          }))
          .filter((s) => s.admNo || s.name || s.className)
      ),
    [sameSchoolSiblings]
  );

  const otherSchoolJson = useMemo(
    () =>
      JSON.stringify(
        otherSchoolSiblings
          .map((s) => ({
            schoolName: s.schoolName?.trim(),
            name: s.name?.trim(),
            className: s.className?.trim(),
          }))
          .filter((s) => s.schoolName || s.name || s.className)
      ),
    [otherSchoolSiblings]
  );

  const updateSame = (idx, key, value) => {
    setSameSchoolSiblings((prev) => {
      const copy = [...prev];
      copy[idx] = { ...copy[idx], [key]: value };
      return copy;
    });
  };

  const updateOther = (idx, key, value) => {
    setOtherSchoolSiblings((prev) => {
      const copy = [...prev];
      copy[idx] = { ...copy[idx], [key]: value };
      return copy;
    });
  };

  const addSame = () =>
    setSameSchoolSiblings((p) => [...p, { admNo: "", name: "", className: "" }]);

  const removeSame = (idx) =>
    setSameSchoolSiblings((p) => p.filter((_, i) => i !== idx));

  const addOther = () =>
    setOtherSchoolSiblings((p) => [
      ...p,
      { schoolName: "", name: "", className: "" },
    ]);

  const removeOther = (idx) =>
    setOtherSchoolSiblings((p) => p.filter((_, i) => i !== idx));

  const isAnyFilled = (obj) =>
    Object.values(obj).some((v) => String(v || "").trim() !== "");

  const isAllFilled = (obj) =>
    Object.values(obj).every((v) => String(v || "").trim() !== "");

  const validate = () => {
    const nextErrors = {};

    // validate sibling rows (same school)
    sameSchoolSiblings.forEach((sib, idx) => {
      const row = { admNo: sib.admNo, name: sib.name, className: sib.className };
      if (isAnyFilled(row) && !isAllFilled(row)) {
        nextErrors[`sameSibling_${idx}`] =
          "Please fill ADM NO, NAME and CLASS for this sibling row (or clear it).";
      }
    });

    // validate sibling rows (other school)
    otherSchoolSiblings.forEach((sib, idx) => {
      const row = {
        schoolName: sib.schoolName,
        name: sib.name,
        className: sib.className,
      };
      if (isAnyFilled(row) && !isAllFilled(row)) {
        nextErrors[`otherSibling_${idx}`] =
          "Please fill SCHOOL NAME, NAME and CLASS for this sibling row (or clear it).";
      }
    });

    // DOB not in future
    const dob = formRef.current?.elements?.dob?.value;
    if (dob) {
      const dobDate = new Date(dob);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      if (dobDate > today) nextErrors.dob = "DOB cannot be a future date.";
    }

    // 10-digit mobile validation
    const mobileFields = ["studentMobile", "fatherMobile", "motherMobile"];
    mobileFields.forEach((name) => {
      const val = formRef.current?.elements?.[name]?.value || "";
      if (val && !/^\d{10}$/.test(val)) {
        nextErrors[name] = "Please enter a valid 10-digit mobile number.";
      }
    });

    setErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const onSubmit = (e) => {
    e.preventDefault();
    setSuccessMsg("");

    // Browser-level validation first
    if (!formRef.current.checkValidity()) {
      formRef.current.reportValidity();
      return;
    }

    // Custom validation
    const ok = validate();
    if (!ok) return;

    // Submit to Apps Script (no fetch)
    formRef.current.submit();

    // Success message + reset
    setSuccessMsg("Form submitted successfully!");
    formRef.current.reset();

    // Reset sibling UI
    setSameSchoolSiblings([{ admNo: "", name: "", className: "" }]);
    setOtherSchoolSiblings([{ schoolName: "", name: "", className: "" }]);
    setErrors({});
  };

  return (
    <>
      <Header />

      <Breadcrumb
        title="Admission Class XI"
        mid="Academic &nbsp; &nbsp;|"
        tabName="Admission Class XI"
      />

      <div className="innerPage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <form
                ref={formRef}
                action={GOOGLE_SCRIPT_URL}
                method="POST"
                target="hidden_iframe"
                onSubmit={onSubmit}
                noValidate
              >
                {/* Fixed values */}
                <div style={rowStyle}>
                  <div style={fieldStyle}>
                    <label>Class (2025–26)</label>
                    <input
                      name="classYear"
                      value="2026-27"
                      readOnly
                      style={inputStyle}
                    />
                  </div>

                  <div style={fieldStyle}>
                    <label>Value (Default)</label>
                    <input
                      name="classValue"
                      value="Class 11"
                      readOnly
                      style={inputStyle}
                    />
                  </div>

                  <div style={fieldStyle}>
                    <label>Stream applying for Class 11th</label>
                    <select name="stream" required style={inputStyle}>
                      <option value="">Select Stream</option>
                      {streams.map((s) => (
                        <option key={s} value={s}>
                          {s}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <h3>Student Details</h3>
                <div style={gridStyle}>
                  <div style={fieldStyle}>
                    <label>Name of the Student</label>
                    <input
                      name="studentName"
                       required
                      minLength={3}
                      style={inputStyle}
                    />
                  </div>

                  <div style={fieldStyle}>
                    <label>DOB</label>
                    <input type="date" name="dob"  required style={inputStyle} />
                    {errors.dob && <div style={errText}>{errors.dob}</div>}
                  </div>

                  <div style={fieldStyle}>
                    <label>Email ID</label>
                    <input type="email" name="email"  required style={inputStyle} />
                  </div>

                  <div style={fieldStyle}>
                    <label>Student Mobile No</label>
                    <input
                      name="studentMobile"
                      
                      inputMode="numeric"
                      // ✅ FIX: must escape backslash in JSX
                      
                      placeholder="10-digit number"
                      style={inputStyle}
                    />
                    {errors.studentMobile && (
                      <div style={errText}>{errors.studentMobile}</div>
                    )}
                  </div>

                  <div style={fieldStyle}>
                    <label>Gender</label>
                    <select name="gender" required style={inputStyle}>
                      <option value="">Select Gender</option>
                      {genders.map((g) => (
                        <option key={g} value={g}>
                          {g}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div style={{ ...fieldStyle, gridColumn: "1 / -1" }}>
                    <label>Present Residential Address</label>
                    <textarea
                      name="address"
                      rows={3}
                      required
                      minLength={10}
                      style={inputStyle}
                    />
                  </div>

                  <div style={fieldStyle}>
                    <label>Last School Attended</label>
                    <input name="lastSchoolAttended" required  style={inputStyle} />
                  </div>

                  <div style={fieldStyle}>
                    <label>Affiliated to which Board</label>
                    <input name="boardAffiliated" required style={inputStyle} />
                  </div>
                </div>

                <h3>Father’s Details</h3>
                <div style={gridStyle}>
                  <div style={fieldStyle}>
                    <label>Father’s Name</label>
                    <input name="fatherName" required style={inputStyle} />
                  </div>

                  <div style={fieldStyle}>
                    <label>Father Mobile No</label>
                    <input
                      name="fatherMobile"
                      required
                      inputMode="numeric"
                      
                      placeholder="10-digit number"
                      style={inputStyle}
                    />
                    {errors.fatherMobile && (
                      <div style={errText}>{errors.fatherMobile}</div>
                    )}
                  </div>

                  <div style={fieldStyle}>
                    <label>Father Organization</label>
                    <input name="fatherOrg" style={inputStyle} />
                  </div>

                  <div style={fieldStyle}>
                    <label>Father’s Occupation</label>
                    <input name="fatherOccupation" style={inputStyle} />
                  </div>
                </div>

                <h3>Mother’s Details</h3>
                <div style={gridStyle}>
                  <div style={fieldStyle}>
                    <label>Mother’s Name</label>
                    <input name="motherName" required style={inputStyle} />
                  </div>

                  <div style={fieldStyle}>
                    <label>Mother Mobile No</label>
                    <input
                      name="motherMobile"
                      
                      inputMode="numeric"
required
                      placeholder="10-digit number"
                      style={inputStyle}
                    />
                    {errors.motherMobile && (
                      <div style={errText}>{errors.motherMobile}</div>
                    )}
                  </div>

                  <div style={fieldStyle}>
                    <label>Mother Organization</label>
                    <input name="motherOrg" style={inputStyle} />
                  </div>

                  <div style={fieldStyle}>
                    <label>Mother’s Occupation</label>
                    <input name="motherOccupation" style={inputStyle} />
                  </div>
                </div>

                <h3>Sibling details (in same School)</h3>
                <p style={{ marginTop: -8, opacity: 0.75 }}>
                  Add sibling rows if applicable.
                </p>

                {sameSchoolSiblings.map((sib, idx) => (
                  <div key={`same-${idx}`} style={siblingRowStyle}>
                    <input
                      placeholder="ADM NO."
                      value={sib.admNo}
                      onChange={(e) => updateSame(idx, "admNo", e.target.value)}
                      style={inputStyle}
                    />
                    <input
                      placeholder="NAME"
                      value={sib.name}
                      onChange={(e) => updateSame(idx, "name", e.target.value)}
                      style={inputStyle}
                    />
                    <input
                      placeholder="CLASS"
                      value={sib.className}
                      onChange={(e) => updateSame(idx, "className", e.target.value)}
                      style={inputStyle}
                    />

                    {sameSchoolSiblings.length > 1 && (
                      <button
                        type="button"
                        onClick={() => removeSame(idx)}
                        style={btnAlt}
                      >
                        Remove
                      </button>
                    )}

                    {errors[`sameSibling_${idx}`] && (
                      <div style={{ ...errText, gridColumn: "1 / -1" }}>
                        {errors[`sameSibling_${idx}`]}
                      </div>
                    )}
                  </div>
                ))}

                <button type="button" onClick={addSame} style={btn}>
                  + Add Sibling (Same School)
                </button>

                <h3 style={{ marginTop: 20 }}>Sibling details (in Other School)</h3>
                <p style={{ marginTop: -8, opacity: 0.75 }}>
                  Add sibling rows if applicable.
                </p>

                {otherSchoolSiblings.map((sib, idx) => (
                  <div key={`other-${idx}`} style={siblingRowStyle}>
                    <input
                      placeholder="SCHOOL NAME"
                      value={sib.schoolName}
                      onChange={(e) => updateOther(idx, "schoolName", e.target.value)}
                      style={inputStyle}
                    />
                    <input
                      placeholder="NAME"
                      value={sib.name}
                      onChange={(e) => updateOther(idx, "name", e.target.value)}
                      style={inputStyle}
                    />
                    <input
                      placeholder="CLASS"
                      value={sib.className}
                      onChange={(e) => updateOther(idx, "className", e.target.value)}
                      style={inputStyle}
                    />

                    {otherSchoolSiblings.length > 1 && (
                      <button
                        type="button"
                        onClick={() => removeOther(idx)}
                        style={btnAlt}
                      >
                        Remove
                      </button>
                    )}

                    {errors[`otherSibling_${idx}`] && (
                      <div style={{ ...errText, gridColumn: "1 / -1" }}>
                        {errors[`otherSibling_${idx}`]}
                      </div>
                    )}
                  </div>
                ))}

                <button type="button" onClick={addOther} style={btn}>
                  + Add Sibling (Other School)
                </button>

                {/* Hidden fields stored in sheet */}
                <input
                  type="hidden"
                  name="sameSchoolSiblings"
                  value={sameSchoolJson}
                />
                <input
                  type="hidden"
                  name="otherSchoolSiblings"
                  value={otherSchoolJson}
                />

                <div style={{ marginTop: 20 }}>
                  <button type="submit" style={{ ...btn, padding: "10px 16px" }}>
                    Submit
                  </button>
                </div>

                {successMsg && (
                  <div style={{ marginTop: 12, color: "green" }}>
                    {successMsg}
                  </div>
                )}

                {/* prevents page reload */}
                <iframe
                  name="hidden_iframe"
                  style={{ display: "none" }}
                  title="hidden_iframe"
                />
              </form>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default AdmissionClassXI;

/** basic styles */
const gridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  gap: 12,
  marginBottom: 12,
};

const rowStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  gap: 12,
  marginBottom: 16,
};

const fieldStyle = {
  display: "flex",
  flexDirection: "column",
  gap: 6,
};

const inputStyle = {
  padding: "10px 12px",
  border: "1px solid #ccc",
  borderRadius: 8,
  outline: "none",
  fontSize: 14,
};

const siblingRowStyle = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr 1fr auto",
  gap: 10,
  alignItems: "center",
  marginBottom: 10,
};

const btn = {
  border: "1px solid #222",
  background: "#222",
  color: "#fff",
  padding: "8px 12px",
  borderRadius: 8,
  cursor: "pointer",
  marginTop: 6,
};

const btnAlt = {
  border: "1px solid #999",
  background: "#fff",
  color: "#222",
  padding: "8px 10px",
  borderRadius: 8,
  cursor: "pointer",
};

const errText = {
  color: "crimson",
  fontSize: 12,
  marginTop: 6,
};